import { render, staticRenderFns } from "./InvoiceAccountsDetails.vue?vue&type=template&id=f1f985f2&"
import script from "./InvoiceAccountsDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceAccountsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports